import React, { useState, useEffect } from 'react';

const IconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
    <path d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

 const EmailNotificationsModal = ({ 
  isOpen, 
  onClose, 
  emails, 
  onAddEmail, 
  onRemoveEmail, 
  onEditEmail,
  editSettings 
}) => {
  const [newEmail, setNewEmail] = useState('');
  const [editingIdx, setEditingIdx] = useState(null);
  const [editingEmail, setEditingEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setNewEmail('');
      setEditingIdx(null);
      setEditingEmail('');
      setEmailError('');
    }
  }, [isOpen]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleAddEmail = () => {
    if (!newEmail.trim()) {
      setEmailError('Please enter an email address');
      return;
    }
    if (!validateEmail(newEmail)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    if (emails.includes(newEmail)) {
      setEmailError('This email is already added');
      return;
    }
    onAddEmail(newEmail);
    setNewEmail('');
    setEmailError('');
  };

  const handleSaveEdit = () => {
    if (!editingEmail.trim()) {
      setEmailError('Please enter an email address');
      return;
    }
    if (!validateEmail(editingEmail)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    if (editingEmail !== emails[editingIdx] && emails.includes(editingEmail)) {
      setEmailError('This email is already added');
      return;
    }
    onEditEmail(editingIdx, editingEmail);
    setEditingIdx(null);
    setEditingEmail('');
    setEmailError('');
  };

  if (!isOpen) return null;

  return (
    <div className="cfg-modal-backdrop" onClick={onClose}>
      <div className="cfg-modal" onClick={e => e.stopPropagation()} style={{ width: '550px' }}>
        
        {/* Header */}
        <div className="cfg-modal-header">
          <span className="cfg-modal-title">API Failure Email Notifications</span>
          <button 
            type="button"
            className="cfg-modal-close" 
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="cfg-modal-body">

          {editingIdx === null && (
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                <input
                  type="email"
                  className="cfg-input"
                  value={newEmail}
                  onChange={e => { setNewEmail(e.target.value); setEmailError(''); }}
                  disabled={!editSettings}
                  placeholder="admin@example.com"
                />
                <button
                  onClick={handleAddEmail}
                  disabled={!editSettings || !newEmail.trim()}
                  className="cfg-modal-btn cfg-modal-btn--save"
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  + Add
                </button>
              </div>
              {emailError && (
                <div style={{ color: '#ff6b6b', fontSize: '0.85rem', marginTop: '4px' }}>
                  {emailError}
                </div>
              )}
            </div>
          )}

          {/* Emails */}
          {emails.length === 0 ? (
            <div style={{
              padding: '20px',
              borderRadius: '4px',
              border: '1px dashed #6b8fb5',
              textAlign: 'center',
              color: '#6b8fb5'
            }}>
              <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem' }}>No email addresses configured yet</p>
              <small style={{ fontSize: '0.85rem', opacity: '0.8' }}>Add email addresses above to receive API failure notifications</small>
            </div>
          ) : (
            <div style={{
              border: '1px solid #4cc3e6',
              borderRadius: '4px',
              maxHeight: '300px',
              overflowY: 'auto'
            }}>
              {emails.map((email, idx) => (
                <div 
                  key={idx} 
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '12px',
                    borderBottom: idx < emails.length - 1 ? '1px solid rgba(76, 195, 230, 0.2)' : 'none'
                  }}
                >
                  {editingIdx === idx ? (
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <input
                        type="email"
                        className="cfg-input"
                        value={editingEmail}
                        onChange={e => { setEditingEmail(e.target.value); setEmailError(''); }}
                        placeholder="admin@example.com"
                        style={{ flex: 1 }}
                        autoFocus
                      />
                      <button
                        onClick={handleSaveEdit}
                        disabled={!editSettings}
                        className="cfg-modal-btn cfg-modal-btn--save"
                        style={{
                          whiteSpace: 'nowrap',
                          minWidth: '70px'
                        }}
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setEditingIdx(null);
                          setEditingEmail('');
                          setEmailError('');
                        }}
                        disabled={!editSettings}
                        className="cfg-modal-btn cfg-modal-btn--cancel"
                        style={{
                          whiteSpace: 'nowrap',
                          minWidth: '70px'
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className='flexRow justifyContentSpaceBetween alignItemsCenter'>
                      <span style={{ fontSize: '0.9rem', color: '#fff', flex: 1 }}>{email}</span>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button
                          onClick={() => {
                            setEditingIdx(idx);
                            setEditingEmail(email);
                          }}
                          disabled={!editSettings}
                          style={{
                            width: '36px',
                            height: '36px',
                            padding: '6px',
                            backgroundColor: 'transparent',
                            borderRadius: '30px',
                            color: '#fff',
                            cursor: editSettings ? 'pointer' : 'not-allowed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: editSettings ? 1 : 0.5,
                            transition: 'background-color 0.2s ease, color 0.2s ease',
                            border: 'none',
                            outline: 'none',
                            boxShadow: 'none'
                          }}
                          onMouseOut={(e) => {
                            if (editSettings) {
                              e.currentTarget.style.backgroundColor = 'transparent';
                              e.currentTarget.style.color = '#fff';
                            }
                          }}
                          onMouseOver={(e) => {
                            if (editSettings) {
                              e.currentTarget.style.backgroundColor = 'rgba(76, 195, 230, 0.88)';
                              e.currentTarget.style.color = '#fff';
                            }
                          }}
                          title="Edit"
                        >
                          <IconEdit />
                        </button>
                        <button
                          onClick={() => onRemoveEmail(idx)}
                          disabled={!editSettings}
                          style={{
                            width: '36px',
                            height: '36px',
                            padding: '6px',
                            backgroundColor: 'transparent',
                            color: '#ff6b6b',
                            borderRadius: '30px',
                            cursor: editSettings ? 'pointer' : 'not-allowed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: editSettings ? 1 : 0.5,
                            transition: 'all 0.2s ease',
                            fontSize: '16px',
                            fontWeight: 'bold'
                          }}
                          title="Remove"
                          onMouseOut={(e) => {
                            if (editSettings) {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#ff6b6b';
                            }
                          }}
                          onMouseOver={(e) => {
                            if (editSettings) {
                              e.target.style.backgroundColor = 'rgba(224, 92, 92, 0.1)';
                              e.target.style.color = '#ff6b6b';
                            }
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {emailError && editingIdx !== null && (
            <div style={{ color: '#ff6b6b', fontSize: '0.85rem', marginTop: '8px' }}>
              {emailError}
            </div>
          )}

        </div>
        <div className="cfg-modal-footer">
          <button 
            className="cfg-modal-btn cfg-modal-btn--cancel"
            onClick={onClose}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

export default EmailNotificationsModal;